import { render, staticRenderFns } from "./CalendarViewConstructor.vue?vue&type=template&id=70546be9"
import script from "./CalendarViewConstructor.vue?vue&type=script&lang=js"
export * from "./CalendarViewConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70546be9')) {
      api.createRecord('70546be9', component.options)
    } else {
      api.reload('70546be9', component.options)
    }
    module.hot.accept("./CalendarViewConstructor.vue?vue&type=template&id=70546be9", function () {
      api.rerender('70546be9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar-view-constructor/CalendarViewConstructor.vue"
export default component.exports